module.exports = __webpack_public_path__ + "static/media/worldflag.ef7d993b.svg";